// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sort-toggle[data-v-7079d8b2]{position:relative;display:inline-block;height:1rem}.sort-arrow[data-v-7079d8b2]{position:absolute;top:.25rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
